import config from "./dev";

export default {
  apiUrl: config.apiUrl,
  releaseStage: config.releaseStage
};
